<div class="audit-details-container" [formGroup]="auditWithDetailsForm">
    <div class="page-header-container">
      <div class="flex flex-row justify-between">
        <div class="header-composed">
          <a (click)="navigateBack()" class="text-title-2 back-ref">
            {{(navigationState | navigatedFrom : 'Audits' : '/audits')?.name}}
          </a>
          <div class="text-title-2 header">
            Audit Details
          </div>
        </div>
        <app-button class="pl-2"
          subStyle="white"
          icon="icon-print"
          text="Print"
          [disabled]="isFileDownloading"
          (clicked)="print()"
        ></app-button>
      </div>
    
        <div class="page-subheader">
          <div class="audit-metadata">
            <div class="label">Create Date:</div>
            <div class="value">
              {{auditWithDetails?.createDate | formattedDate: 'MM d a, HH:mm'}}
            </div>
          </div>
          <div class="audit-metadata max-w-[15%]" *ngIf="!!auditWithDetails.name">
            <div class="label">Name:</div>
            <div class="value truncate">
              {{auditWithDetails.name}}
            </div>
          </div>
          <div class="audit-metadata">
            <div class="label">Type:</div>
            <div class="value">
              <span *ngIf="auditWithDetails?.type === AuditTypesEnum.AdHoc">
                Ad Hoc
              </span>
              <span *ngIf="auditWithDetails?.type === AuditTypesEnum.AllDrugs">
                All Drugs
              </span>
              <span *ngIf="auditWithDetails?.type === AuditTypesEnum.ActiveDrugs">
                Active Drugs
              </span>
              <span *ngIf="auditWithDetails?.type === AuditTypesEnum.InactiveDrugs">
                Inactive Drugs
              </span>
              <span *ngIf="auditWithDetails?.type === AuditTypesEnum.NinetyDayAudit">
                90 Day Audit Report
              </span>
              <span *ngIf="auditWithDetails.type === AuditTypesEnum.BackCount">
                Back Count
              </span>
              <span *ngIf="auditWithDetails.type === AuditTypesEnum.TotalsOnly">
                Totals Only Audit
              </span>
              {{getAuditTypeSuffix()}}
            </div>
          </div>
          <div class="audit-metadata max-w-[43%]" *ngIf="inventoryLocationsEnabled$ | async">
            <div class="label" *ngIf="locationsInHeader">Locations:</div>
            <div class="value truncate">
              {{locationsInHeader}}
            </div>
          </div>
          <div class="audit-metadata">
            <div class="label">Status:</div>
            <div class="value mt-[2px] !ml-2">
              <app-badge *ngIf="auditWithDetails?.status === AuditStatusesEnum.Pending" [color]="BadgeColorsEnum.Yellow">
                Pending
            </app-badge>
            <app-badge *ngIf="auditWithDetails?.status === AuditStatusesEnum.InProgress" [color]="BadgeColorsEnum.Blue">
                In Progress
            </app-badge>
            <app-badge *ngIf="auditWithDetails?.status === AuditStatusesEnum.Completed" [color]="BadgeColorsEnum.Green">
                Complete
            </app-badge>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-row">
      <div class="search-scanner pl-8 pb-4" *ngIf="auditWithDetails?.status !== AuditStatusesEnum.Completed && auditWithDetails?.type !== AuditTypesEnum.BackCount">
        <app-input-search-scanner
          (optionSelected)="ndcSelected($event)"
          [isInventory]="true"
          [placeholder]="'Scan barcode (Or search drug name, NDC)'"
          [loading]="loading$ | async"
          [disable]="loading$ | async"
          [searchOnlyC2s]="auditWithDetails?.type === AuditTypesEnum.NinetyDayAudit"
          [locationsToExclude]="locationsToExcludeFromSearchScanner"
          [searchEmptyInventory]="true"
          label="Which drug(s) do you wish to audit?"
          #searchScanner
        ></app-input-search-scanner>
      </div>
      <app-alert *ngIf="drugAlreadyAddedAlert$ | async"
        [show]="true"
        [message]="'Drug already added to audit.'"
        type="error"
        class="ml-4 mt-3"
        [autohide]="2"
        (closeAlert)="drugAlreadyAddedAlert$.next(false)"
      ></app-alert>
    </div>
      
      <div class="table-scroll-wrapper" *ngIf="auditWithDetails?.details?.length || auditWithDetailsForm?.controls?.details?.length else empty">
        <table class="table-primary audit-details" [ngClass]="auditWithDetails?.type === AuditTypesEnum.NinetyDayAudit || auditWithDetails?.type === AuditTypesEnum.TotalsOnly ? 'ninety-day-audit' : ''">
          <thead>
          <tr>
            <th (click)="sortColumn('friendlyName')" class="text-left sort drug" scope="col">
              NDCs  
              <img [class.asc]="tableColumns.friendlyName" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
            </th>
            <th (click)="sortColumn('inventoryLocationName')" class="text-left sort location" scope="col" *ngIf="inventoryLocationsEnabled$ | async">
              Location  
              <img [class.asc]="tableColumns.inventoryLocationName" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
            </th>
            <ng-container *ngIf="auditWithDetails?.type === AuditTypesEnum.NinetyDayAudit || auditWithDetails?.type === AuditTypesEnum.TotalsOnly">
              <th class="qty-column text-right" scope="col">Start</th>
              <th class="qty-column text-right" scope="col">In</th>
              <th class="qty-column text-right" scope="col">Out</th>
            </ng-container>
            <th class="text-right on-hand" scope="col">{{auditWithDetails?.type === AuditTypesEnum.NinetyDayAudit || auditWithDetails?.type === AuditTypesEnum.TotalsOnly ? 'Inventory' : 'Expected Inventory'}}</th>
            <th class="text-right actualCount" scope="col">Actual Count</th>
            <th class="text-right discrepancy" scope="col">Discrepancy</th>
            <th class="text-right adjustments" scope="col">Adjustments</th>
            <th class="adjustment-btns" [class.no-controls]="auditWithDetails?.type === AuditTypesEnum.BackCount"></th>
            <th class="text-right delete-control" scope="col" *ngIf="auditWithDetails?.type !== AuditTypesEnum.BackCount">
              <!-- Controls -->
            </th>
          </tr>
          </thead>
          <tbody [ngClass]="{'completed-audit': this.auditWithDetails?.status === AuditStatusesEnum.Completed}" 
            [class.back-count-audit]="auditWithDetails?.type === AuditTypesEnum.BackCount">
            <ng-container formArrayName="details" *ngFor="let rowData of auditWithDetailsForm?.controls?.details?.value; let i = index; trackBy:trackByIndex">
              <tr class="table-row" [formGroupName]="i">
                <td class="text-left drug">
                  <div class="heading">
                    {{rowData?.friendlyName}}
                    <ng-container *ngIf="shouldDisplayPendingTransactions(rowData)">
                      <app-tooltip [template]="pendingTransactionsTooltip" *ngIf="getPendingTransactionsCount(rowData.id) > 0"
                        [data]="getDetailPendingTransactions(rowData)" [width]="340" [position]="getPositionForPendingTransactionTooltip()">
                        <div class="pending-transaction yellow">
                          <div class="pending-transaction-content"><img [src]="getPendingTransactionIconPath(rowData.id)" class="icon-info"/> <span class="count"
                            [class.count-white]="rowData?.actualCountState === ActualCountStatesEnum.NotFinishedPendingTransaction"
                            >{{getPendingTransactionsCount(rowData.id)}}</span>
                          </div>
                        </div>
                      </app-tooltip>
                    </ng-container>
                  </div>
                  <div class="secondary">
                    {{rowData?.packageNDC11Digit}}
                  </div>
                </td>
                <td class="text-left location" *ngIf="inventoryLocationsEnabled$ | async">
                  {{rowData?.inventoryLocationName}}
                </td>
                <ng-container *ngIf="auditWithDetails?.type === AuditTypesEnum.NinetyDayAudit || auditWithDetails?.type === AuditTypesEnum.TotalsOnly">
                  <td class="qty-column text-right">
                    {{rowData.start | number}}
                  </td>
                  <td class="qty-column text-right">
                    {{rowData.in | number}}
                  </td>
                  <td class="qty-column text-right">
                    {{rowData.out | number}}
                  </td>
                </ng-container>
                <td class="text-right on-hand">
                  {{rowData?.initialInventoryCount | number}}
                </td>
                <!-- Confrimed audit details -->
                <ng-container  *ngIf="rowData?.confirmationDate">
                  <td class="text-right actualCount confirmed !pl-14">
                    <app-input
                    [initialValue]="rowData?.actualCount || '0'"
                    [type]="'number'"
                    customClasses="!pr-8"
                    textAlign="right"
                    [isNdcQty]="true"
                    [ignoreInput]="true"
                    icon="done-green"
                    iconClasses="!top-[9px] !right-[9px] !h-[18px] !w-[18px]"
                  > 
                  </app-input>
                  </td>
                  <td class="text-right discrepancy">
                    0
                  </td>
                  <td class="text-right adjustments">
                    <div class="flex justify-end !text-[#0284C7] !font-medium" *ngIf="calcAdjustments(rowData?.id) > 0">
                      {{getConfirmedAdjustmentNumberSign(rowData?.id)}}{{calcAdjustments(rowData?.id)}} 
                      <app-discrepancy-info-with-tooltip [data]="getConfirmedDetailTooltipData(rowData?.id)"
                      class="pl-2 pt-[1px]" [tooltipPosition]="getPositionForDiscrepancyTooltip()" ></app-discrepancy-info-with-tooltip>
                    </div>
                    <span *ngIf="calcAdjustments(rowData?.id) === 0">0</span>
                  </td>
                  <td class="confirmed-audit-info">
                    <div class="secondary">
                      Confirmed:
                    </div>
                    <div>
                    <span class="font-medium"> {{rowData?.confirmByFirstName}} {{rowData?.confirmByLastName}} </span> <span class="secondary"> | {{rowData?.confirmationDate | formattedDate: 'MM d a, HH:mm'}}</span>
                    </div>
                  </td>
                 
                </ng-container>
                <!-- Unconfrimed audit details -->
                <ng-container *ngIf="!rowData?.confirmationDate">
                  <td class="text-right actualCount !pl-14" 
                    [ngClass]="auditWithDetailsForm.controls.details.controls[i].controls?.actualCount.valid ? 'pending' : 'error'">
                    <app-input
                      formControlName="actualCount"
                      [type]="'number'"
                      customClasses="!pr-8"
                      [showErrors]="false"
                      textAlign="right"
                      [isNdcQty]="true"
                      (focused)="onFocus(i)"
                      (blurred)="onBlur(i)"
                      (keyupEnter)="focusNextInput(i)"
                      [icon]="getIcon(rowData?.actualCountState)"
                      [iconClasses]="iconClasses"
                      [min]="0"
                      (onIconClick)="onInputIconClick(i)"
                    > 
                    </app-input>
                  </td>
                
                  <td class="text-right discrepancy !text-[#991B1B] !font-medium">
                    {{calcAddedDiscrepancy(rowData?.id)}}
                  </td>

                  <td class="text-right adjustments !text-[#0284C7] !font-medium" *ngIf="calcAddedAdjustments(rowData?.id) > 0">
                    <div class="flex justify-end">
                      {{getAddedAdjustmentNumberSign(rowData?.id)}}{{calcAddedAdjustments(rowData?.id)}} 
                      <app-discrepancy-info-with-tooltip [data]="getDetailAdjustments(rowData?.id)"
                      [tooltipPosition]="getPositionForDiscrepancyTooltip()"
                      (removeAdjustment)="removeAdjustmentHandler($event)"
                      class="pl-2 pt-[1px]"></app-discrepancy-info-with-tooltip>
                    </div>
                  </td>
                  <td class="text-right adjustments" *ngIf="calcAddedAdjustments(rowData?.id) === 0"> </td>
                  <td class="adjustment-btns" [class.no-controls]="auditWithDetails?.type === AuditTypesEnum.BackCount">
                    <div class="flex flex-row" *ngIf="calcAddedDiscrepancy(rowData?.id) > 0 || calcAddedDiscrepancy(rowData?.id) < 0">
                      <app-audit-details-adjustments-transaction 
                        [detail]="rowData"
                        (noteOtherReasonOptionSelected)="addNewNote(rowData)"
                        [discrepancy]="calcAddedDiscrepancy(rowData?.id)"
                        (adjustmentAdded)="adjustmentAddedHandler($event)">
                      </app-audit-details-adjustments-transaction>
                    </div>
                    <app-button *ngIf="calcAddedDiscrepancy(rowData?.id) === 0 && calcAddedAdjustments(rowData?.id) > 0"
                      text="Confirm adjustment" customClasses="px-4" [minWidth]="0" class="receive" (clicked)="validateInventory(i)">
                    </app-button>
                  </td>
                  <td class="delete-control" *ngIf="auditWithDetails?.type !== AuditTypesEnum.BackCount">
                  <div class="delete-icon"
                    (click)="removeDetail(i)">
                  </div>
                  </td>
                </ng-container>
              </tr>
            </ng-container>
          </tbody>
        </table>

        <div class="audit-controls-container" *ngIf="auditWithDetails?.details?.length || auditWithDetailsForm?.controls?.details?.length">
          <div class="label">
            Confirmed {{getConfirmedDetailsCount()}} of {{auditWithDetails?.details?.length}} NDCs
          </div>
          <app-button *ngIf="auditWithDetails?.details?.length !== getConfirmedDetailsCount(); else completeAudit"
            text="Confirm NDCs"
            customClasses="px-4"
            [minWidth]="0"
            class="receive"
            (clicked)="validateInventory()"
            [disabled]="!atLeastOneValid()"
          >
          </app-button>
          <ng-template #completeAudit>
            <app-button *ngIf="auditWithDetails?.status !== AuditStatusesEnum.Completed"
              text="Complete audit"
              customClasses="px-4"
              [minWidth]="0"
              class="receive"
              (clicked)="onCompleteAudit()"
          >
            </app-button>
        </ng-template>
        </div>
      </div>
</div>

<app-enter-pin-dialog *ngIf="showPinDialog"
    [show]="true"
    [focusPin]="focusPin"
    (cancel)="closeDialog()"
    (setPinHandler)="validatePin($event)"
    (handleResetPin)="openResetPinDialog()"
></app-enter-pin-dialog>

<app-reset-pin-dialog *ngIf="showResetPinDialog"
                      [show]="true"
                      (cancel)="closeResetPinDialog()"
                      (afterUpdate)="afterPinUpdated($event)"
></app-reset-pin-dialog>

<ng-template #empty>
  <app-empty-table *ngIf="!(loading$ | async)"
    labelValue="You haven't selected a drug to audit."
    icon="scanner"
    [topOffset]="250"
  ></app-empty-table>
</ng-template>

<app-audit-details-note-modal *ngIf="currentNoteDetails"
  [leftDiscrepancyToAdjust]="calcLeftDiscrepancyToAdjust(this.currentNoteDetails?.auditDetailId)"
  [noteDetails]="currentNoteDetails"
  (cancel)="currentNoteDetails = null; currentNoteAdjustmentQtyInvalid = false"
  (submit)="noteModalSubmitted($event)"
></app-audit-details-note-modal>

<app-dialog
  [header]="'Expected Inventory has Changed'"
  [subHeader]="inventoryChangedModalText"
  [maxWidth]="490"
  [minWidth]="560"
  [headerIcon]="'warning'"
  [show]="displayInventoryChangedModal">
    <div class="flex flex-row-reverse">
        <app-button customClasses="px-4" [text]="'Ok'" class="save-btn" (click)="displayInventoryChangedModal=false" [minWidth]="50">
        </app-button>
    </div>
</app-dialog>

<ng-template #pendingTransactionsTooltip let-transactions="transactions" let-locationsToExclude="locationsToExclude">
  <div class="p-2 pl-3">
    <div class="flex flex-row">
      <div class="qty">{{transactions?.length}}</div>
      <span class="ml-3"> {{transactions?.length === 1 ? 'Pending Transaction:' : 'Pending Transactions:'}}</span>
    </div>
    <div class="tooltip-item card">
      <app-pending-transaction-cards
        cardCustomClasses="mt-3"
        [items]="transactions"
        (openConfirmationDialog)="openConfirmPendingTransactionsModal($event, locationsToExclude)"
      ></app-pending-transaction-cards> 
    </div>
  </div>
</ng-template>

<app-pending-transaction-dialog *ngIf="showConfirmPendingTransactionDialog"
  [show]="true"
  [locationsToExclude]="locationsToExcludeFromThePendingTransactionCard"
  [hideBackCount]="true"
  (cancel)="showConfirmPendingTransactionDialog = false" (confirmed)="pendingTransactionConfirmedHandler($event)" 
  (openSelf)="showConfirmPendingTransactionDialog = true" (updated)="pendingTransactionUpdated($event)"
  [splitNdcsOn]="false"
></app-pending-transaction-dialog>

<app-dialog
  *ngIf="pendingDeleteDrugModal$ | async; let pendingDeleteDrugModal"
  [showHeader]="true"
  header="Are you sure you want to delete?"
  subHeader="Deleting a drug will change this audit to an Ad Hoc audit.  Proceed?"
  [maxWidth]="490"
  [minWidth]="560"
  [headerIcon]="'warning'"
  [show]="true">
    <div class="flex justify-between">
        <app-button customClasses="px-4" text="Cancel" [minWidth]="0" subStyle="transparent" class="cancel-btn"
        (clicked)="pendingDeleteDrugModal$.next(null)" >
        </app-button>
        <app-button customClasses="px-4" [text]="'OK'" class="save-btn" (clicked)="deletingConfirmed(pendingDeleteDrugModal.idxToRemove)"  [minWidth]="50">
        </app-button>
    </div>
</app-dialog>

<app-dialog
  *ngIf="pendingAddDrugModal$ | async; let pendingAddDrugModal"
  [showHeader]="true"
  header="Are you sure you want to add?"
  subHeader="Adding a drug will change this audit to an Ad Hoc audit.  Proceed?"
  [maxWidth]="490"
  [minWidth]="560"
  [headerIcon]="'warning'"
  [show]="true">
    <div class="flex justify-between">
        <app-button customClasses="px-4" text="Cancel" [minWidth]="0" subStyle="transparent" class="cancel-btn"
        (clicked)="searchScanner?.resetSearch(); pendingAddDrugModal$.next(null)" >
        </app-button>
        <app-button customClasses="px-4" [text]="'OK'" class="save-btn" (clicked)="addingConfirmed(pendingAddDrugModal.selectedNdc)"  [minWidth]="50">
        </app-button>
    </div>
</app-dialog>


<app-dialog *ngIf="updateFromBodToEodAlert"
  [showHeader]="true"
  header="Time of Audit Changed"
  subHeader="Updating to End of Day (EOD) for the End Date because inventory changed."
  [maxWidth]="490"
  [minWidth]="560"
  [headerIcon]="'warning'"
  [show]="true">
    <div class="flex flex-row-reverse">
        <app-button customClasses="px-4" [text]="'OK'" class="save-btn" [minWidth]="50" (clicked)="updateFromBodToEodAlert = false">
        </app-button>
    </div>
</app-dialog>

<app-dialog *ngIf="newNdcAddedAlert"
  [showHeader]="true"
  header="New NDC Added"
  subHeader="Please audit the new NDC(s) before finishing the audit."
  [maxWidth]="490"
  [minWidth]="560"
  [headerIcon]="'warning'"
  [show]="true">
    <div class="flex flex-row-reverse">
        <app-button customClasses="px-4" [text]="'OK'" class="save-btn"  [minWidth]="50" (clicked)="newNdcAddedAlert = false">
        </app-button>
    </div>
</app-dialog>

<app-dialog *ngIf="ninetyDayAuditExpiredAlert$ | async"
  [showHeader]="true"
  header="Type of Audit Changed"
  subHeader="This audit no longer qualifies as a 90 day audit and has been switched to an ad hoc audit."
  [maxWidth]="490"
  [minWidth]="560"
  [headerIcon]="'warning'"
  [show]="true">
    <div class="flex flex-row-reverse">
        <app-button customClasses="px-4" [text]="'OK'" class="save-btn"  [minWidth]="50" (clicked)="ninetyDayAuditExpiredAlert$.next(false)">
        </app-button>
    </div>
</app-dialog>

<app-loading *ngIf="(loading$ | async) && showLoader">
  Processing your audit...
  <br>
  this may take a moment
</app-loading>